import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Dialog, Typography } from "@mui/material";
import moment from "moment";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { AppColors } from "../../../util/AppColors";
import { extensionToMime } from "../../../util/function";

const DiagnosticsView = ({
  diagnostics,
  showFileAlso = false,
  isFilePreview = false,
}) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const imageFiles = useMemo(
    () =>
      selectedFiles?.filter(
        (fle) => fle?.mimeType === "image" || fle?.mimeType === "video",
      ) || [],
    [selectedFiles],
  );

  const handleFileClick = (fle, index, allFiles) => {
    const mimeType =
      extensionToMime[fle?.split(".").pop().split("?")[0].toLowerCase()]?.split(
        "/",
      )?.[0];

    if (mimeType === "application") {
      // ✅ open pdf in new tab
      window.open(fle, "_blank");
    } else if (mimeType === "image" || !mimeType || mimeType === "video") {
      // ✅ open popup for images/videos
      setSelectedFiles(allFiles);
      // Find the index in the filtered imageFiles array
      const imageFilesList =
        allFiles?.filter(
          (f) => f?.mimeType === "image" || f?.mimeType === "video",
        ) || [];
      const imageIndex = imageFilesList.findIndex((f) => f?.file === fle);
      setActiveIndex(imageIndex >= 0 ? imageIndex : 0);
      setOpen(true);
    }
  };

  const renderFiles = (files = []) => {
    const reqList = files?.map((fle, i) => {
      const mimeType =
        extensionToMime[
          fle?.split(".").pop().split("?")[0].toLowerCase()
        ]?.split("/")?.[0];
      return { file: fle, mimeType };
    });

    return reqList?.map((fle, i) => {
      const mimeType = fle?.mimeType;
      return (
        <div
          style={{
            display: "inline-block",
            position: "relative",
            marginLeft: i !== 0 ? 15 : 0,
          }}
          key={i + mimeType}
        >
          {mimeType === "application" ? (
            <PictureAsPdfIcon
              className="upload-pdf"
              sx={{
                color: AppColors.redBtn,
                cursor: isFilePreview ? "pointer" : "default",
              }}
              onClick={() =>
                isFilePreview && handleFileClick(fle?.file, i, reqList)
              }
            />
          ) : mimeType === "image" || !mimeType ? (
            <img
              className="upload-img"
              alt=""
              src={fle?.file}
              onClick={() =>
                isFilePreview && handleFileClick(fle?.file, i, reqList)
              }
              style={{ cursor: isFilePreview ? "pointer" : "default" }}
            />
          ) : mimeType === "video" ? (
            <video
              className="upload-img"
              alt=""
              src={fle?.file}
              onClick={() =>
                isFilePreview && handleFileClick(fle?.file, i, reqList)
              }
              style={{ cursor: isFilePreview ? "pointer" : "default" }}
            />
          ) : null}
        </div>
      );
    });
  };

  const renderRecord = () => {
    return (
      (diagnostics ?? reqDet?.diagnostics)
        // ?.filter((li) => li?.status?.toLowerCase() === "completed")
        ?.map((li, i) => {
          return (
            <div key={Date.now() + i}>
              <div className="flex-row ph10 mv5">
                <div className="w50Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {li?.testName}
                  </Typography>
                </div>
                <div className="w35Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {li?.type}
                  </Typography>
                </div>
                <div className="w15Per pr5">
                  <Typography className="fs12 font-medium black4">
                    {moment(li?.dueDate).format("DD MMM YYYY")}
                  </Typography>
                </div>
              </div>
              {showFileAlso ? renderFiles(li?.file) : null}
            </div>
            // <div className="gray-back-con1 mv5" key={Date.now() + i}>
            //   <div className="flex-row-ali-cen flex-row-wrap">
            //     <Typography className="txt-semi-bold black fs12">
            //       Name: {li?.testName}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Type: {li?.type}
            //     </Typography>
            //     <div className="gray-dot2 mh5" />
            //     <Typography className="font-medium black4 fs12">
            //       Due Date: {moment(li?.dueDate).format("DD MMM YYYY")}
            //     </Typography>
            //   </div>
            // </div>
          );
        })
    );
  };

  return (
    <>
      <div>
        {/* <div className="blk-hor-split mv3" /> */}
        <div className="flex-row-ali-cen ph10">
          <div className="w50Per">
            <Typography className="fs12 txt-semi-bold black">Name</Typography>
          </div>
          <div className="w35Per">
            <Typography className="fs12 txt-semi-bold black">Type</Typography>
          </div>
          <div className="w15Per">
            <Typography className="fs12 txt-semi-bold black">
              Due Date
            </Typography>
          </div>
        </div>
        <div className="blk-hor-split mb3 mt10" />
        {renderRecord()}
        {/* <div className="blk-hor-split mv3" /> */}
      </div>
      {isFilePreview && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <div className="flex-center relative pv20">
            {imageFiles?.length > 0 && (
              <>
                {imageFiles[activeIndex]?.mimeType === "video" ? (
                  <video
                    src={imageFiles[activeIndex]?.file}
                    controls
                    style={{ maxHeight: "70vh", maxWidth: "100%" }}
                    className="br10"
                  />
                ) : (
                  <img
                    src={imageFiles[activeIndex]?.file}
                    alt=""
                    style={{ maxHeight: "70vh", maxWidth: "100%" }}
                    className="br10"
                  />
                )}
              </>
            )}

            {/* Close button */}
            <CloseIcon
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
                color: AppColors.red2,
              }}
              onClick={() => setOpen(false)}
            />

            {/* Left arrow */}
            {imageFiles?.length > 1 && activeIndex > 0 && (
              <div
                onClick={() => setActiveIndex((prev) => prev - 1)}
                style={{
                  position: "absolute",
                  left: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  background: "rgba(0,0,0,0.3)",
                  borderRadius: "50%",
                  width: 30,
                  height: 30,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <ChevronLeftIcon sx={{ color: "white", fontSize: 20 }} />
              </div>
            )}

            {/* Right arrow */}
            {imageFiles?.length > 1 && activeIndex < imageFiles.length - 1 && (
              <div
                onClick={() => setActiveIndex((prev) => prev + 1)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  background: "rgba(0,0,0,0.3)",
                  borderRadius: "50%",
                  width: 30,
                  height: 30,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <ChevronRightIcon sx={{ color: "white", fontSize: 20 }} />
              </div>
            )}
          </div>
        </Dialog>
      )}
    </>
  );
};

export default DiagnosticsView;
